import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SignalWifi4BarLockIcon(props: IconProps) {
    return <Icon {...props} iconKey={"signal_wifi_4_bar_lock"}/>
}
